// removed by extract-text-webpack-plugin
module.exports = {"msignaturepad":"styles__msignaturepad___3IAvD","m-signature-pad--body":"styles__m-signature-pad--body___1BnSp","m-signature-pad--footer":"styles__m-signature-pad--footer___1Yq8E","description":"styles__description___2uI2-","button":"styles__button___2vo5M","clear":"styles__clear___3I0g8","save":"styles__save___3SY_u","m-signature-pad":"styles__m-signature-pad___uvUpw","github":"styles__github___3Di0c","uploadLink":"styles__uploadLink___ckoQn","centerFont":"styles__centerFont___2NdHp"};


//////////////////
// WEBPACK FOOTER
// ./client/app/shared/components/UploadManager/styles.scss
// module id = eorU
// module chunks = client